$(document).ready(function () {
    // Validate Resource File Form
    var ResourceFileForm     = $('#resources-file-form');
    var CopyResourceFileForm = $('#resources-copy-file-form');

    $(ResourceFileForm).validate({
        onkeyup: false,
        onclick: false,
        ignore: ':hidden, [contenteditable="true"]:not([name])',
        rules: {
            name: {
                required: true,
                minlength: 5,
                maxlength: 255,
            },
            file: {
                required: true,
            },
        },
        messages: {
            name: {
                required: 'Please give your resource a name.',
                minlength: 'Name must be a minimum of 5 characters.',
                maxlength: 'Name must be a maximum of 255 characters.',
            },
            file: {
                required: 'Please upload your resource.',
            },
        },
    });

    $(CopyResourceFileForm).validate({
        onkeyup: false,
        onclick: false,
        ignore: ':hidden, [contenteditable="true"]:not([name])',
        rules: {
            searchresource: {
                required: true,
            },
        },
        messages: {
            searchresource: {
                required: 'Please enter keywords to select a resource.',
            },
        },
    });

    $('#event-searchresource').select2({
        width: '100%',
        theme: 'bootstrap',
        minimumInputLength: 3,
        ajax: {
            url: base_url + 'resources/ajax_existingresources',
            dataType: 'json',
            delay: 250,
            type: 'GET',
            data: function (params) {
                var queryParameters = {
                    term: params.term,
                };
                return queryParameters;
            },
            processResults: function (data) {
                return {
                    results: $.map(data, function (item) {
                        var typeofresource = item.extension == '' ? item.type : item.extension;
                        var resourcename = item.title == item.name ? item.name : item.name + ' - ' + item.title;
                        var eventdate = dayjs.unix(item.start).format(MEDIUMDATE);
                        return {
                            title: item.name,
                            id: item.id,
                            text: resourcename + ' ' + eventdate + ' (' + typeofresource + ')',
                            // Workaround for Select2 4.1.0 Ajax search issue (GitHub issue #6423)
                            _resultId: 'search-resource-result-' + item.id,
                        };
                    }),
                };
            },
        },
        templateSelection: function (item) {
            return item.text;
        },
    });

    $('#sortable2').sortable({
        containment: 'parent',
        scroll: true,
        update: function (event, ui) {
            $(this).children().each(function (index) {
                // Strict comparison cannot be used in the check below
                if (!$(this).hasClass('heading') && $(this).attr('data-event-position') != index) {
                    $(this).attr('data-event-position', index).addClass('updated');
                }
            });

            saveUpdatedPositions();
        },
    });
});

/**
 * Function for ajax call to update event resource positions
 *
 * @return void
 */
function saveUpdatedPositions() {
    var positions = [];
    $('.updated').each(function () {
        positions.push([$(this).attr('data-event-resource'), $(this).attr('data-event-position')]);
        $(this).removeClass('updated');
    });

    $.ajax({
        url: base_url + 'timetable/ajax_positions',
        type: 'get',
        dataType: 'json',
        data: {
            postionsData: positions,
        },
    });
}
